import moment from 'moment';
import React from 'react';

const columns = [
	{
		id: 'license_key',
		name: 'License Key',
		sortable: true,
		selector: row => row.license_key,
		cell: row => row.license_key,
		width: '380px'
	}, {
		id: 'client_id',
		name: 'Client ID',
		sortable: true,
		selector: row => row.client_id,
		cell: row => row.client_id,
		width: '220px'
	}, {
		id: 'purchase_date',
		name: 'Purchase Date',
		sortable: true,
		selector: row => row.purchase_date,
		cell: row => row.purchase_date ? moment(row.purchase_date).format('DD/MM/YYYY') : '-',
		width: '160px'
	}, {
		id: 'expiration_date',
		name: 'Expiry Date',
		sortable: true,
		selector: row => row.expiration_date,
		cell: row => row.expiration_date ? moment(row.expiration_date).format('DD/MM/YYYY') : '-',
		width: '160px'
	}, {
		id: 'status',
		name: 'Status',
		sortable: true,
		selector: row => row.status,
		cell: row => {
			const status = row.status;
			let color = '#9E9E9E'; // default gray
			
			if (status === 'active') {
				color = '#16cb1d'; // green
			} else if (status === 'pending') {
				color = '#ff9800'; // orange/yellow
			} else if (status === 'expired') {
				color = '#f44336'; // red
			}
			
			return (
				<span style={{color: color, fontWeight: '500'}}>
					{status ? status.charAt(0).toUpperCase() + status.slice(1) : '-'}
				</span>
			);
		},
		width: '140px'
	}, {
		id: 'pricing_tier_name',
		name: 'Pricing Tier',
		sortable: true,
		selector: row => row.pricing_tier_name,
		cell: row => row.pricing_tier_name || '-',
		width: '160px'
	}, {
		id: 'created_at',
		name: 'Created Date',
		sortable: true,
		selector: row => row.created_at,
		cell: row => row.created_at ? moment(row.created_at).format('DD/MM/YYYY') : '-',
		width: '160px'
	}, {
		id: 'actions',
		name: '', // Empty name to remove the header
		sortable: false,
		hideFilter: true, // Hide filter icon for this column
		selector: row => row.id,
		cell: (row, index, column, id) => {
			// Only show delete icon for pending licenses
			if (row.status === 'pending') {
				return (
					<div style={{ 
						display: 'flex', 
						justifyContent: 'center', 
						alignItems: 'center', 
						height: '100%',
						width: '100%'
					}}>
						<button
							className="delete-license-btn"
							data-license-id={row.id}
							data-license-key={row.license_key}
							style={{
								background: 'none',
								border: 'none',
								cursor: 'pointer',
								padding: '8px',
								borderRadius: '4px',
								transition: 'background-color 0.2s',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								minWidth: '32px',
								minHeight: '32px'
							}}
							onMouseOver={(e) => {
								e.target.style.backgroundColor = '#f5f5f5';
							}}
							onMouseOut={(e) => {
								e.target.style.backgroundColor = 'transparent';
							}}
							title="Delete License"
						>
							<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" fill="#f44336"/>
							</svg>
						</button>
					</div>
				);
			}
			return null;
		},
		width: '80px'
	}
];

export default columns; 